<template>
  <div>
    <b-modal
      id="modal_itens"
      title="Adicionar Produto"
      ref="my-modal"
      size="lg"
      hide-footer
      modal-class="modal-add-product"
      @show="resetModal"
      @hidden="resetModal"
      scrollable
    >
      <!-- Client Info Bar -->
      <div v-if="getFormData && getFormData.dataCapaPedido && getFormData.dataCapaPedido.clientenomeabreviado" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ getFormData.dataCapaPedido.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <!-- Chip TABELA removido a pedido do cliente -->
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ totalItensNoPedido }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Seletor de tipo de busca -->
      <b-row class="mb-1 mt-1">
        <b-col md="12">
          <b-form-group label="Tipo de Busca:">
            <b-form-radio-group
              v-model="tipoBusca"
              :options="opcoesTypeBusca"
              @change="onTipoBuscaChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Busca por marca e categoria -->
      <b-row v-if="tipoBusca === 'marca-categoria'" class="gx-3 gy-2 align-items-center justify-content-center">
        <!-- Marca -->
        <b-col md="3">
          <b-form-group label="Marca">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingMarca" />
                <feather-icon
                  icon="TagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteMarca ? '#1f9d57' : '#dc2626'"
                  v-if="!getIsLoadingMarca"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_cod_marca"
                :options="getEsMarcas"
                :state="$store.state.intensPedido.setExisteMarca"
                @change="limparCamposDependendes"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Categoria -->
        <b-col md="3">
          <b-form-group label="Categoria">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingCategoria" />
                <feather-icon
                  icon="ShoppingBagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteCategoria ? '#1f9d57' : '#dc2626'"
                  v-if="!getIsLoadingCategoria"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_categoria"
                :options="getEsCategorias"
                :disabled="!selected_cod_marca || getIsLoadingCategoria || getIsLoadingReferencia || isLoadingAllData"
                :state="$store.state.intensPedido.setExisteCategoria"
                @change="limparReferencia"
              />
              <b-form-invalid-feedback
                v-show="!getIsLoadingCategoria && !$store.state.intensPedido.setExisteCategoria && selected_cod_marca"
                tooltip
              >
                A marca selecionada não possui categorias cadastradas.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Botão Buscar e Limpar -->
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="primary"
              block
              class="mt-1"
              :disabled="!selected_cod_marca || !selected_categoria || isLoadingAllData"
              @click="buscarReferencias"
            >
              <feather-icon icon="SearchIcon" size="18" class="mr-1" />
              Buscar
            </b-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="danger"
              block
              class="mt-1"
              @click="limparFiltros"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-1" />
              Limpar
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Busca por código de referência -->
      <b-row v-if="tipoBusca === 'codigo-referencia'" class="gx-3 gy-2 align-items-center justify-content-center">
        <b-col md="3">
          <b-form-group label="Código da Referência">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingReferencia" />
                <feather-icon icon="PackageIcon" size="18" v-if="!getIsLoadingReferencia" />
              </b-input-group-prepend>
              <b-form-input
                v-model="codigo_referencia_direto"
                placeholder="Digite o código da referência"
                :disabled="isLoadingAllData"
                @keyup.enter="buscarPorCodigoReferencia"
                @blur="trimCodigoReferencia"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="primary"
              block
              class="mt-1"
              :disabled="!codigo_referencia_direto || isLoadingAllData"
              @click="buscarPorCodigoReferencia"
            >
              <feather-icon icon="SearchIcon" size="18" class="mr-1" />
              Buscar
            </b-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="danger"
              block
              class="mt-1"
              @click="limparFiltros"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-1" />
              Limpar
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Totais -->
      <b-row class="justify-content-end mt-3">
        <b-col cols="auto" class="text-right">
          <p><strong>Total de Pedidos:</strong> {{ totalUnidades }}</p>
          <p>
            <strong>Total Valor:</strong>
            {{ dinheiroVisual(totalVisualItens) }}
          </p>
        </b-col>
      </b-row>

      <!-- Loading -->
      <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
        <b-spinner small type="grow" class="mr-2"></b-spinner>
        Carregando mais itens...
      </div>

      <!-- Inserção de Itens -->
      <inserir-item-modal
        :cotacoes-preco-visuais="cotacoesVisuais"
        :tipo-pedido-preco-visual="tipoPedidoVisual"
        :before-add-item="prepararItemParaAdicionar"
        @update:grade-item="updatedGradeItens"
        @calcular-imposto="calcularImposto"
        @remove-item="handleRemoveItem"
        @select-item="carregarDetalheReferencia"
      />

      <!-- Carregar mais itens (lazy/paginado + scroll infinito) -->
      <div v-if="temMaisReferencias" class="text-center my-2">
        <!-- Sentinela do IntersectionObserver: dispara o próximo bloco ao chegar perto do fim -->
        <div ref="sentinelaCarregarMais" class="sentinela-carregar-mais"></div>
        <b-button v-if="!isLoadingAllData" variant="outline-primary" @click="carregarMaisReferencias">
          <feather-icon icon="ChevronDownIcon" size="16" class="mr-50" />
          Carregar mais itens ({{ referenciasPendentes.length }} restantes)
        </b-button>
      </div>

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itensTabela.length > 0">
          <span class="summary-count">{{ itensTabela.length }} item(s)</span>
          <span class="summary-separator">|</span>
          <span class="summary-total">{{ dinheiroVisual(totalVisualItens) }}</span>
        </div>
        <div class="actions-buttons" :class="{ 'ml-auto': itensTabela.length === 0 }">
           <b-button variant="outline-secondary" @click="$refs['my-modal'].hide()">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
           <b-button variant="success" @click="handleOk" :disabled="!podeAdicionarItens">
             <feather-icon icon="CheckIcon" size="16" class="mr-50" />
             Salvar
           </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BFormInput, BCol, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue';
import axios from '@axios';
import InserirItemModal from '@/views/app/operacoes/pedidosVendas/inserirItemModal.vue';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import adicionarProdutoModalMixin from '@/views/app/operacoes/pedidosVendas/modal/adicionarProdutoModal.mixin';
import { aplicarPrecoDoacao } from '@/utils/impostoSimulador';
import { selecionarNaturezaFiscal } from '@/utils/naturezaFiscal';
import { precoFinalSimulado, precoTabelaSimulado } from '@/utils/precoProveniencia';

export default {
  components: {
    InserirItemModal,
    BButton,
    BFormInput,
    BModal,
    BCol,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
  },
  mixins: [adicionarProdutoModalMixin],
  data() {
    return {
      calculationGeneration: 0,
      modalEpoch: 0,
      calculationPending: false,
      selectionCalculationReady: false,
    };
  },
  computed: {
    podeAdicionarItens() {
      const linhasCalculadas = this.itensTabela.filter((item) => item._requiresCurrentCalculation);
      return this.novosItensAdicionados
        && this.selectionCalculationReady
        && !this.calculationPending
        && linhasCalculadas.length > 0
        && linhasCalculadas.every((item) => item._calculationReady === true
          && Number.isFinite(Number(item.precoComImposto))
          && Number(item.precoComImposto) > 0
          && item._calculationContext === this._contextoCalculo(item));
    },
  },
  methods: {
    /**
     * Fonte de dados específica do fluxo "Pedido Padrão": a capa do pedido
     * fica em intensPedido/getFormData.dataCapaPedido (não em InfoPedido,
     * que este fluxo não popula).
     */
    getTabelaPrecoId() {
      return this.getFormData?.dataCapaPedido?.tabelaprecoid;
    },
    async show() {
      await this.$bvModal.show('modal_itens');
      this.$root.$emit('modal:opened');
      this.$root.$emit('modal:sync-items');
      await this.getMarcaPedido();
    },
    // Lê a capa do pedido padrão (intensPedido) para a simulação de imposto.
    _capaImposto() {
      const capa = this.getFormData?.dataCapaPedido || {};
      const endereco = this.getFormData?.enderecoEntrega || {};
      return {
        estabelecimentoid: capa.estabelecimentoid || '',
        clienteNomeAbreviado: capa.clientenomeabreviado || '',
        tabelaprecoid: capa.tabelaprecoid || '',
        condicaopagamentoid: Number(capa.condicaopagamentoid || 0),
        naturezaoperacaoid: selecionarNaturezaFiscal(capa, { endereco }),
        canal_venda_id: capa.canalvendaid || capa.canal_venda_id || '',
        ufid: endereco.ufid || '',
        cidade: endereco.clienteenderecocidade || '',
        isentoIE: capa.clienteisentoie ? 1 : 0,
        tipopedidoid: capa.tipopedidoid
          || capa.tipoPedido?.tipopedidoid
          || this.getFormData?.tipoPedido?.tipopedidoid
          || '',
        pedidoDoacao: capa.pedidoDoacao === true
          || capa.isPedidoDoacao === true
          || String(capa.tipopedidoid || '').toUpperCase() === 'WD',
      };
    },
    async carregarDetalheReferencia(product) {
      if (!product || product._detalheCarregado || product._carregandoDetalhe) return;
      const modalEpoch = this.modalEpoch;
      const selectedSku = product.item_id ?? product.itemId ?? product.CodItem;
      this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: true } });
      try {
        const apiCache = {};

        const simularImpostoWithCache = async (itemId, precoUnitarioBase) => {
          const capa = this._capaImposto();

          if (!capa.estabelecimentoid || !capa.clienteNomeAbreviado || !capa.tabelaprecoid || (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !capa.condicaopagamentoid)) {
            return null;
          }

          const cacheKey = JSON.stringify([itemId, precoUnitarioBase, capa]);
          if (apiCache[cacheKey] !== undefined) return apiCache[cacheKey];

          try {
            const quote = await this.consultarCotacaoLocalOuErp(itemId, 1, precoUnitarioBase);
            this.registrarCotacaoVisual(itemId, quote);
            const precoComImposto = quote && !quote._erro
              ? precoFinalSimulado(aplicarPrecoDoacao(quote, String(capa.tipopedidoid || '').toUpperCase() === 'WD', capa.tipopedidoid)) : null;
            apiCache[cacheKey] = precoComImposto;
            return precoComImposto;
          } catch (e) {
            console.error('Erro ao simular impostos (pré-exibição):', e);
            apiCache[cacheKey] = null;
            return null;
          }
        };

        const refCode = product.referencia ?? 0;
        const detalhes = await this.getDetalhesItem(
          refCode, product.cod_marca, product.cod_categ, selectedSku,
        );

        if (!detalhes || !detalhes.Result) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const itemData = detalhes.Result?.data?.Result
          || detalhes.Result?.data
          || detalhes.Result?.Result
          || detalhes.Result
          || detalhes.data?.Result
          || detalhes.data || {};
        const exactItem = itemData?.item || {};

        const allNullBlocks = (
          !itemData?.imagens
          && !itemData?.Embalagens
          && !itemData?.corTamanho
          && !itemData?.tabelaPreco
          && !itemData?.familiaComercial
        );

        if (allNullBlocks || !itemData) {
          console.warn(`Referência ${refCode} sem dados detalhados úteis.`);
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const corTamanhoArr = Array.isArray(itemData.corTamanho) ? itemData.corTamanho : [];
        const gradeBuilt = (() => {
          const ttHBIgrade = corTamanhoArr.map((row) => ({
            cdnCor: row.cdn_cor,
            desCor: row.des_cor,
            itemExtrapq: row.pp?.item_id || null,
            itemPequeno: row.p?.item_id || null,
            itemMedio: row.m?.item_id || null,
            itemGrande: row.g?.item_id || null,
            itemExtraGd: row.gg?.item_id || null,
            itemSuperGd: row.xg?.item_id || null,
            itemUltraGd: row.xgg?.item_id || null,
            itemUnico: row.unico?.item_id || null,
            itemOutros: row.diversos?.item_id || null,
          })).filter((r) => r.cdnCor || r.desCor);
          return ttHBIgrade.length > 0 ? { dsHBIgrade: { ttHBIgrade } } : null;
        })();

        const embalagensArray = Array.isArray(itemData.Embalagens) ? itemData.Embalagens : [];
        const embalagensProcessadas = embalagensArray.map((embalagem) => ({
          descricao_embalagem: embalagem.des_embalag,
          cdn_embalagem: embalagem.cdn_embalagem,
          grade: gradeBuilt,
          itemMultiplo: 0,
        }));

        // Preserve the exact list row SKU instead of selecting a sibling from
        // the family grade.
        const firstSkuId = selectedSku;

        const precoBase = Number(itemData.tabelaPreco?.[0]?.tabelapreco_item_preco
          ?? itemData.tabelaPreco?.[0]?.preco
          ?? exactItem.preco ?? product.item_price_base ?? product.item_price ?? 0);
        const precoComImposto = firstSkuId ? await simularImpostoWithCache(firstSkuId, precoBase) : null;

        const imagemPrincipal = Array.isArray(itemData.imagens)
          ? itemData.imagens.find((img) => img.imagemPrincipal === 1)
          : null;
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;

        const fallbackPreco = Number(itemData.tabelaPreco?.[0]?.tabelapreco_item_preco
          ?? itemData.tabelaPreco?.[0]?.preco
          ?? exactItem.preco ?? product.item_price_base ?? product.item_price ?? 0);
        if (modalEpoch !== this.modalEpoch) return;
        const precoCalculado = Number(precoComImposto);
        const unitPrice = precoComImposto !== null && Number.isFinite(precoCalculado)
          ? precoCalculado
          : null;
        const familiaItemId = itemData.familiaComercial?.[0]?.item_id ?? '';
        const selectedDescricao = product.item_descricao ?? product.itemDescricao
          ?? product.Descricao ?? exactItem.item_descricao ?? exactItem.itemDescricao
          ?? itemData.item_descricao ?? itemData.itemDescricao
          ?? itemData.familiaComercial?.[0]?.Referencia ?? product.item_name;

        this.atualizarItemJsonTelaNovaPedido({
          referencia: product.referencia,
          itemId: selectedSku,
          patch: {
            item_name: selectedDescricao,
            item_descricao: selectedDescricao,
            itemDescricao: selectedDescricao,
            Descricao: itemData.Descricao ?? selectedDescricao,
            item_price_base: Number(fallbackPreco),
            item_price: unitPrice,
            item_marca: itemData.Marca?.[0]?.des_marca ?? exactItem.item_marca ?? product.item_marca,
            cod_marca: itemData.Marca?.[0]?.cod_marca ?? exactItem.cod_marca ?? product.cod_marca,
            imagens: itemData.imagens || [],
            item_img_princial: caminhoImagemPrincipal,
            embalagens: embalagensProcessadas.filter((emb) => emb !== null),
            familiaItemId,
            itemIdUnico: selectedSku,
            cdnCorUnico: product.cdn_cor ?? exactItem.cdn_cor
              ?? corTamanhoArr.find((row) => row?.cdn_cor)?.cdn_cor ?? 0,
            desCorUnico: product.des_cor ?? exactItem.des_cor
              ?? corTamanhoArr.find((row) => row?.des_cor)?.des_cor ?? null,
            cdnTamanhoUnico: product.cdn_tamanho ?? exactItem.cdn_tamanho ?? null,
            desTamanhoUnico: product.des_tamanho ?? exactItem.des_tamanho ?? null,
            cdnEmbalagemUnico: product.cdn_embalagem ?? exactItem.cdn_embalagem ?? null,
            desEmbalagemUnico: product.des_embalag ?? exactItem.des_embalag ?? null,
            _detalheCarregado: true,
          },
        });

        if (selectedSku) {
          try {
            await new SLSEstoqueService().consultarEstoque([String(selectedSku)]);
          } catch (e) {
            console.warn('[modalAdicionarItens][padrao] Falha ao consultar estoque:', e);
          }
        }
      } catch (error) {
        console.error(`Erro ao carregar detalhe da referência ${product?.referencia}:`, error);
        if (modalEpoch === this.modalEpoch) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
        }
      } finally {
        if (modalEpoch === this.modalEpoch) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: false } });
        }
      }
    },
    async consultarCotacaoLocalOuErp(itemId, quantidade, precoUnitario) {
      const capa = this._capaImposto();
      const { data } = await axios.post('imposto/simular', {
        estabelecimentoid: capa.estabelecimentoid,
        clienteId: this.getFormData?.dataCapaPedido?.clienteid,
        clienteNomeAbreviado: capa.clienteNomeAbreviado,
        naturezaOperacaoId: capa.naturezaoperacaoid,
        canalVendaId: capa.canal_venda_id,
        itemId,
        quantidade,
        precoUnitario,
        ufDs: capa.ufid,
        cidadeDs: capa.cidade,
        contribuinteIcms: capa.isentoIE ? 0 : 1,
        tabelaPrecoId: capa.tabelaprecoid,
        condicaoPagamentoId: capa.condicaopagamentoid,
      });
      return data?.data || null;
    },
    async calcularImposto(newItem) {
      Swal.fire({
        title: 'Calculando impostos',
        html: 'Por favor, aguarde...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      this.isCalculandoImposto = true;

      try {
        const capa = this._capaImposto();

        const camposObrigatorios = [
          { valor: capa.estabelecimentoid, nome: 'Estabelecimento' },
          { valor: capa.clienteNomeAbreviado, nome: 'Cliente' },
          { valor: capa.tabelaprecoid, nome: 'Tabela de Preço' },
          ...(this.$store.getters['preferencias/condicaoPagamentoAtiva'] ? [{ valor: capa.condicaopagamentoid, nome: 'Condição de Pagamento' }] : []),
        ];

        const camposFaltando = camposObrigatorios.filter((campo) => !campo.valor);

        if (camposFaltando.length > 0) {
          Swal.close();

          camposFaltando.forEach((campo) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Campo Obrigatório',
                text: `${campo.nome} não foi selecionado. Por favor, complete os dados do pedido.`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            });
          });

          throw new Error(`Campos obrigatórios não preenchidos: ${camposFaltando.map((c) => c.nome).join(', ')}`);
        }

        const retorno = await this.consultarCotacaoLocalOuErp(
          newItem.item_id, newItem.valor, newItem.precoUnitario,
        );
        if (retorno && !retorno._erro) {
          this.registrarCotacaoVisual(newItem.item_id, retorno);
          const precoImposto = precoFinalSimulado(aplicarPrecoDoacao(retorno, String(capa.tipopedidoid || '').toUpperCase() === 'WD', capa.tipopedidoid));
          const valorBaseIcms = retorno.baseIcms || 0;
          const valorIcms = retorno.valorIcms || 0;
          const naturezaoperacaoidimposto = retorno.naturezaOperacao || 0;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Imposto calculado com sucesso!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          return {
            precoComImposto: precoImposto,
            precoTabelaErp: precoTabelaSimulado(retorno),
            baseIcms: valorBaseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
          };
        }
        return null;
      } catch (error) {
        console.error('Erro ao calcular impostos:', error);

        if (!error.message.includes('Campos obrigatórios não preenchidos')) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: error.message || 'Erro ao calcular impostos',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }

        return null;
      } finally {
        Swal.close();
        this.isCalculandoImposto = false;
      }
    },
    _linhaKey(item) {
      return [
        item.itemId ?? item.item_id,
        item.cdn_embalagem ?? '',
        item.des_cor ?? '',
        item.desc_tamanho ?? item.tamanho ?? '',
      ].map((part) => String(part)).join('|');
    },
    _contextoCalculo(item) {
      const capa = this._capaImposto();
      return JSON.stringify([
        this._linhaKey(item),
        Number(item.precoUnitario),
        parseInt(item.valor ?? item.pedidoItemQuantidade, 10),
        capa.estabelecimentoid,
        capa.clienteNomeAbreviado,
        capa.tabelaprecoid,
        capa.condicaopagamentoid,
        capa.naturezaoperacaoid,
        capa.canal_venda_id,
        capa.ufid,
        capa.cidade,
        capa.isentoIE,
        capa.tipopedidoid,
        capa.pedidoDoacao,
      ]);
    },
    async prepararItemParaAdicionar(item) {
      const generation = ++this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      const context = this._contextoCalculo(item);
      this.calculationPending = true;
      this.selectionCalculationReady = false;
      const impostos = await this.calcularImposto({
        item_id: item.item_id,
        precoUnitario: item.precoUnitario,
        valor: item.valor,
      });
      if (generation !== this.calculationGeneration
        || modalEpoch !== this.modalEpoch
        || context !== this._contextoCalculo(item)) return null;
      const precoEfetivo = Number(impostos?.precoComImposto);
      if (!impostos || !Number.isFinite(precoEfetivo) || precoEfetivo <= 0) {
        this.calculationPending = false;
        return null;
      }
      return {
        ...item,
        _currentCalculation: { ...impostos, precoComImposto: precoEfetivo },
        _currentCalculationContext: context,
      };
    },
    async updatedGradeItens(value) {
      const selecionados = Array.isArray(value) ? value.filter(Boolean) : [];
      const generation = ++this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      const contexts = selecionados.map((item) => this._contextoCalculo(item));
      this.calculationPending = selecionados.length > 0;
      this.selectionCalculationReady = false;
      if (selecionados.length === 0) return;

      const calculados = [];
      for (let index = 0; index < selecionados.length; index += 1) {
        const item = selecionados[index];
        const quantidade = parseInt(item.valor, 10);
        let impostos = item._currentCalculationContext === contexts[index]
          ? item._currentCalculation
          : null;
        if (!impostos) {
          // eslint-disable-next-line no-await-in-loop
          impostos = await this.calcularImposto({
            item_id: item.item_id,
            precoUnitario: item.precoUnitario,
            valor: quantidade,
          });
        }
        if (generation !== this.calculationGeneration
          || modalEpoch !== this.modalEpoch
          || contexts[index] !== this._contextoCalculo(item)) return;
        const precoEfetivo = Number(impostos?.precoComImposto);
        if (!impostos || !Number.isFinite(precoEfetivo) || precoEfetivo <= 0
          || !Number.isFinite(quantidade) || quantidade <= 0) {
          this.calculationPending = false;
          return;
        }
        calculados.push({ item, quantidade, impostos: { ...impostos, precoComImposto: precoEfetivo } });
      }

      calculados.forEach(({ item, quantidade, impostos }) => {
        const {
          precoComImposto, baseIcms, valorIcms, naturezaoperacaoidimposto,
        } = impostos;
        const precoUnitario = Number(item.precoUnitario);
        const valorTotal = quantidade * precoComImposto;
        const newItem = {
        item_id: item.item_id,
        itemId: item.item_id,
        item_descricao: `${item.nome} ${item.tamanho} ${item.des_cor}`.trim(),
        descricao_referencia: item.nome,
        familiaComercialId: item.referencia,
        codMarca: this.selected_cod_marca,
        marca: item.marca,
        cdn_cor: item.cdn_cor,
        cdncor: item.cdn_cor,
        des_cor: item.des_cor,
        cdn_tamanho: item.tamanho,
        desc_tamanho: item.tamanho,
        embalagem: item.embalagem,
        cdn_embalagem: item.cdn_embalagem,
        quantidade,
        pedidoItemQuantidade: quantidade,
        valor: quantidade,
        valorUnitario: precoUnitario,
        precoUnitario,
        precoComImposto,
        precoTabelaErp: impostos.precoTabelaErp,
        baseIcms,
        valorIcms,
        naturezaoperacaoidimposto,
        valorTotal,
        itemMultiplo: item.itemMultiplo || 1,
        _requiresCurrentCalculation: true,
        _calculationReady: true,
        _calculationContext: this._contextoCalculo(item),
      };
        const idxExistente = this.itensTabela.findIndex(
          (linha) => this._linhaKey(linha) === this._linhaKey(newItem),
        );
        if (idxExistente === -1) this.itensTabela.push(newItem);
        else this.$set(this.itensTabela, idxExistente, { ...this.itensTabela[idxExistente], ...newItem });
      });
      this.calculationPending = false;
      this.selectionCalculationReady = true;
      this.novosItensAdicionados = true;
    },
    async addItens() {
      // Substitui a lista com os itens achatados acumulados na modal.
      // Usa o caminho de array (SET_LISTA_TABELA_ITENS) — o caminho de push
      // (SET_TABELA_ITENS) espera estrutura agrupada com `itens[]`.
      const flat = this.itensTabela.map((it) => ({ ...it }));
      await this.setListTabelaItens(flat);
    },
    /**
     * Remoção EXATA de uma linha (sobrescreve o handleRemoveItem do mixin, que
     * usa correspondência ambígua por itemId OU quantidade). Como os itens deste
     * fluxo são achatados por SKU, a identidade da linha é
     * item_id + cor + tamanho + embalagem. Remove apenas a primeira linha
     * correspondente, preservando outras linhas com a mesma quantidade.
     */
    handleRemoveItem(item) {
      this.calculationGeneration += 1;
      this.calculationPending = false;
      const idx = this.itensTabela.findIndex((i) => String(i.item_id) === String(item.item_id)
        && String(i.cdn_cor ?? '') === String(item.cdn_cor ?? '')
        && String(i.desc_tamanho ?? '') === String(item.tamanho ?? '')
        && String(i.cdn_embalagem ?? '') === String(item.cdn_embalagem ?? ''));

      if (idx !== -1) {
        this.itensTabela.splice(idx, 1);
      }

      this.novosItensAdicionados = this.itensTabela.length > 0;
      this.selectionCalculationReady = this.itensTabela
        .some((linha) => linha._requiresCurrentCalculation && linha._calculationReady);
    },
    async resetModal() {
      this.cotacoesVisuais = {};
      this.modalEpoch += 1;
      this.calculationGeneration += 1;
      this.calculationPending = false;
      this.selectionCalculationReady = false;
      this.tipoBusca = 'marca-categoria';
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.busca_referencia = '';
      this.codigo_referencia_direto = '';
      this.referenciasPendentes = [];
      this.clearModalItens();
      this.novosItensAdicionados = false;

      // Restaura os itens já adicionados (formato achatado do fluxo padrão).
      this.itensTabela = (this.getlistarTabelaItens || []).map((it) => ({ ...it }));
    },
    async handleOk(bvModalEvt) {
      if (bvModalEvt?.preventDefault) bvModalEvt.preventDefault();
      if (!this.podeAdicionarItens) return;
      const generation = this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      await this.addItens();
      if (generation !== this.calculationGeneration || modalEpoch !== this.modalEpoch) return;
      this.handleSubmit();
      this.clearModalItens();
    },
  },
};
</script>

<style scoped>
.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

.modal-add-product {
  --map-primary: var(--sf-accent, #2563eb);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #2563eb);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}

.client-info-bar .client-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.client-info-bar .order-info {
  display: flex;
  gap: 1.5rem;
}

.client-info-bar .info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.client-info-bar .info-content {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.client-info-bar .info-content .label {
  font-size: 0.65rem;
  opacity: 0.8;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #ebe9f1;
}

.modal-actions-footer .items-summary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.modal-actions-footer .actions-buttons {
  display: flex;
  gap: 0.75rem;
}

.sentinela-carregar-mais {
  height: 1px;
  width: 100%;
}
</style>
